import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask, {
  placeholders: {
    F: /[0-9a-f]/i,
    H: /#/
  }
})
